export const getViewHtmlElementId = (viewId: string | undefined) => {
  return `filter-view-${viewId ? viewId : ''}`;
};

export const getViewFolderHtmlElementId = (folderId: string | undefined) => {
  return `filter-view-folder-${folderId ? folderId : ''}`;
};